import { Router, Route } from 'components/core/EasyRouter';
import 'reaction/Stacks.css';
import NewHomepage from 'routes/NewHomepage';
import Portfolio from 'routes/Portfolio';
import PrivateSafe from 'routes/PrivateSafe';
import Services from 'routes/Services';
import './App.css';

export default function App() {
    return (
        <Router>
            <Route path='/'>
                <NewHomepage />
            </Route>
            <Route path='/#/portfolio'>
                <Portfolio />
            </Route>
            <Route path='/#/private'>
                <PrivateSafe />
            </Route>
            <Route path='/#/services'>
                <Services />
            </Route>
        </Router>
    );
}
